import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./App.css";
import RootLayout from "./pages/Root";
import HomePage from "./pages/Home";
import AboutMePage from "./pages/AboutMe";
import ShowsPage from "./pages/Shows";
import ShowDetailPage from "./pages/ShowDetail";
import ArchivePage from "./pages/Archive";
import DionisiachePage from "./pages/Dionisiache";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "about",
        element: <AboutMePage />,
      },
      {
        path: "shows",
        element: <ShowsPage />,
      },
      {
        path: "shows/:showId/:showTitle",
        element: <ShowDetailPage />,
      },
      {
        path: "archive",
        element: <ArchivePage />,
      },
      {
        path: "dionisiache",
        element: <DionisiachePage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
